export default class LinkHelper {
    static dotHtml(str) {
        if (str && str.startsWith('/') && !str.includes('.')) {
            return `${str}.html`;
        }
        return str;
    }
}
